// eslint-disable-next-line import/prefer-default-export
export const ROLES_MANAGE = "roles:manage";
